import { asyncCallRoutePost } from '../helpers/api';

export class EditButton {
	constructor( element ) {
		this.button = element;

		const { routeUrl, _wpnonce } = window.QalaSaveShareCart.editCartRouteObj;

		// Use the existing woocommerce-notices-wrapper is it exists, otherwise create a new one
		this.noticeElementWrapper = document.querySelector( '.woocommerce-notices-wrapper' );

		if ( this.noticeElementWrapper ) {
			this.noticeElement = document.createElement( 'div' );
			this.noticeElementWrapper.appendChild( this.noticeElement );
		}

		this.routeUrl = routeUrl;
		this._wpnonce = _wpnonce;
	}

	/**
	 * Initialize the component, setup all event listeners and such.
	 *
	 * @return {void}
	 */
	init() {
		this.button.disabled = false;
		this.button.addEventListener( 'click', this.handleEditButtonClick.bind( this ) );
	}

	/**
	 * Handle the click event on the edit button.
	 *
	 * @param {Object} event Click event
	 * @return {void}
	 */
	handleEditButtonClick( event ) {
		event.preventDefault();
		this.editCart();
	}

	/**
	 * Edit the cart by sending the request.
	 *
	 * @return {void}
	 */
	async editCart() {
		try {
			const response = await this.startEdit();

			this.validateResponse( response );
			this.endEdit( response );
		} catch ( error ) {
			this.handleErrorResponse( error );
			return false;
		}
	}

	/**
	 * Validates that the response was actually a success.
	 *
	 * @param {Object} response Response object
	 * @return {void}
	 */
	validateResponse( response ) {
		if ( ! response.status ) {
			this.setErrorNotice( response.message );
		}

		if ( response.status !== 200 ) {
			this.setErrorNotice( response.message );
		}
	}

	/**
	 * Starts the edit process.
	 *
	 * @return {Promise} Promise object.
	 */
	async startEdit() {
		return asyncCallRoutePost( this.routeUrl, this._wpnonce, { cartId: this.getCartId(), cartName: this.getCartName(), cartSummary: this.getCartSummary() } );
	}

	/**
	 * Ends the edit process.
	 *
	 * @param {Object} response Response object
	 * @return {void}
	 */
	endEdit( response ) {
		return this.handleResponse( response );
	}

	/**
	 * Handle the response from the server, assuming everything is ok (no server error)
	 *
	 * @param {Object} response
	 */
	handleResponse( response ) {
		this.noticeElement.innerHTML = response.message;
		this.setSuccessNotice( response.message );
	}

	/**
	 * Handle the error response from the server, happens if there is a server error (500)
	 *
	 * @return {void}
	 */
	handleErrorResponse() {
		this.setErrorNotice( window.QalaSaveShareCart.text.unknownError );
	}

	/**
	 * Set the success notice.
	 *
	 * @param {string} text Text to set.
	 * @return {void}
	 */
	setSuccessNotice( text ) {
		if ( ! this.noticeElement ) {
			return;
		}
		this.noticeElement.hidden = false;
		this.noticeElement.innerHTML = text;
		this.noticeElement.classList.remove( 'woocommerce-error' );
		this.noticeElement.classList.add( 'woocommerce-message' );
		this.hideNoticeAfterDelay( this.noticeElement );
	}

	/**
	 * Set the error notice.
	 *
	 * @param {string} text Text to set.
	 * @return {void}
	 */
	setErrorNotice( text ) {
		if ( ! this.noticeElement ) {
			return;
		}

		this.noticeElement.hidden = false;
		this.noticeElement.innerHTML = text;
		this.noticeElement.classList.remove( 'woocommerce-message' );
		this.noticeElement.classList.add( 'woocommerce-error' );
	}

	/**
	 * Clear the notice.
	 *
	 * @return {void}
	 */
	clearNotice() {
		if ( ! this.noticeElement ) {
			return;
		}

		this.noticeElement.innerHTML = '';
		this.noticeElement.classList.remove( 'woocommerce-message' );
		this.noticeElement.classList.remove( 'woocommerce-error' );
	}

	/**
	 * Hide the notice after a delay.
	 *
	 * @param {Element} element
	 * @return {void}
	 */
	hideNoticeAfterDelay( element ) {
		setTimeout( () => {
			element.hidden = true;
		}, 10000 );
	}

	/**
	 * Get the cart ID from the input field.
	 *
	 * @return {string} Cart ID
	 */
	getCartId() {
		return this.button.getAttribute( 'data-cart' );
	}

	/**
	 * Get the cart name from the input field.
	 *
	 * @return {string} Cart ID
	 */
	getCartName() {
		return document.getElementById( 'cart_name' ).value;
	}

	/**
	 * Get the cart summary from the input field.
	 *
	 * @return {string} Cart ID
	 */
	getCartSummary() {
		return document.getElementById( 'cart_summary' ).value;
	}
}
